// Suffixes only — composed with a site prefix (e.g. `PRIMARY/ADD_TO_WISHLIST`)
// by trackWishlistEvent, as the wishlist feature is not tied to one site.
export enum WishlistMixpanelEvents {
	AddToWishlist = 'ADD_TO_WISHLIST',
	RemoveFromWishlist = 'REMOVE_FROM_WISHLIST',
}
